import type { CompareBy } from "@/run-detail/compare-by"

import type { ComparisonPlotConfig } from "@/utils/comparisonPlot"

import { PLOT_REGISTRY } from "../constants"
import type { ComparisonMetricRecordsById } from "../types"

interface PlotOptionsPanelProps {
  config: ComparisonPlotConfig
  metricRecordsById: ComparisonMetricRecordsById
  compareBy: CompareBy | null
  onChange: (next: ComparisonPlotConfig) => void
}

// Right-pane controls for the selected plot. Delegates the body to the plot
// type's own ConfigControls so each plot type owns its options.
export function PlotOptionsPanel({
  config,
  metricRecordsById,
  compareBy,
  onChange,
}: PlotOptionsPanelProps) {
  const entry = PLOT_REGISTRY[config.type]
  return (
    <div className="flex flex-col gap-3">
      <h3 className="text-xs font-semibold uppercase tracking-wide text-coval-text-muted">
        {entry.label} options
      </h3>
      <entry.ConfigControls
        config={config}
        metricRecordsById={metricRecordsById}
        compareBy={compareBy}
        onChange={onChange}
      />
    </div>
  )
}
